import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { WidgetFilterData } from '../models';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  private filterUpdated = new Subject<WidgetFilterData>();
  private searchTermSubject = new Subject<string>();

  public filter: WidgetFilterData = {} as WidgetFilterData;
  public filterUpdated$ = this.filterUpdated.asObservable();
  public searchTerm$ = this.searchTermSubject.asObservable();

  updateFilter(filter: WidgetFilterData): void {
    this.filter = filter;
    this.filterUpdated.next(this.filter);
  }

  public updateSearchTerm(term: string) {
    this.searchTermSubject.next(term);
  }
}